(function () {
    'use strict';

    angular
        .module('tikonApp')
        .factory('MarketplaceSearch', MarketplaceSearch);

    MarketplaceSearch.$inject = ['$resource'];

    function MarketplaceSearch($resource) {
        var resourceUrl = 'api/_search/marketplaces/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true}
        });
    }
})();
